<script setup lang="ts">
import type { ShowcaseContentItemDto } from '@repo/api/web/models'

import ContentBodyRenderer from '#Content/components/Body/ContentBodyRenderer.vue'
import ContentDocuments from '#Content/components/Media/ContentDocuments.vue'
import ContentGallery from '#Content/components/Media/ContentGallery.vue'
import { useContentMedia } from '#Content/composables/useContentMedia'

/**
 * Тело страницы модуля `Info`: материал CMS, если админ завёл его по
 * зарезервированному слагу, иначе — встроенный текст шаблона из слота
 * (SKUBY-CMS-MODULE-SPEC.md §10.3, MR 12a)
 */
const props = defineProps<{
  item?: ShowcaseContentItemDto | null
  hasCmsContent?: boolean
}>()

const item = computed(() => props.item ?? null)
const { images, documents } = useContentMedia(item)
</script>

<template>
  <div v-if="props.hasCmsContent && item">
    <ContentBodyRenderer :body-json="item.bodyJson" />
    <ContentGallery :items="images" />
    <ContentDocuments :items="documents" />
  </div>
  <slot v-else />
</template>
